type EndpointCallErrorOptions = Partial<{ message: string; traceId: string; cause: unknown }>

export class EndpointCallError extends Error {
  public readonly traceId

  constructor(public readonly code: string, messageOrOptions: string | EndpointCallErrorOptions) {
    const { message, traceId, cause } =
      typeof messageOrOptions === 'string'
        ? { message: messageOrOptions, traceId: undefined, cause: undefined }
        : messageOrOptions

    super(message, { cause })

    this.traceId = traceId
    this.name = 'EndpointCallError'
    Object.setPrototypeOf(this, EndpointCallError.prototype)
  }

  toString() {
    return `EndpointCallError [${this.code}] (traceId:${this.traceId ?? ''}): ${this.message}`
  }
}
